define([
    "./hereMapsModule",
    "./configuration/hereMapsConfiguration",
    "./configuration/hereMapsConfigurationLoader",
    "./configuration/hereMapsConfigurationServiceUrl",
    "./configuration/hereMapsLocalization",
    "./hereMapsMarkers/hereMapsMarkersDirective",
    "./hereMapsMarkers/hereMapsMarkersFactory",
    "./hereMapsDirective",
    "./hereMapsController",
    "./hereMapsService",
    "./hereMapsActionsService",
    "./hereMapsConstant",
    "./hereMapsLoadingService",
    "./hereMapsViewportService",
    "./hereMapsRectangleSelectionService",
    "./hereMapsPolygon/hereMapsPolygonDrawingManagerDirective",
    "./hereMapsPolygon/hereMapsPolygonDrawingManagerFactory",
    "./screen/carrierZone/carrierZoneHereMapsDirective",
    "./screen/carrierZone/carrierZoneDrawingService",
    "./screen/carrierZone/carrierZoneFreehandDrawingService",
    "./screen/carrierZone/carrierDrawingCommonService",
    "./screen/locality/localityHereMapsDirective",
    "./screen/monitorable/monitorableHereMapsDirective",
    "./screen/tracking/trackingHereMapsDirective",
    "./hereMapsRoute/hereMapsRoutesFactory",
    "./hereMapsRoute/hereMapsRoutesDirective",
    "./screen/route/nlgRouteHereDirective",
    "./screen/route/tripPanelDirective",
    "./screen/route/routeStopModalService",
    "./screen/route/services/nlgRouteMarkerHereService",
    "./screen/analysisMap/analysisMapViewHereDirective",
    "./screen/analysisMap/analysisMapViewHereController",
    "./screen/analysisMap/services/nlgMarkerHereMapsService"
], function() {
});